// src/app/core/services/plan-error-handler.service.ts
import { Injectable, signal } from '@angular/core';
import { UpgradeDialogData } from '../../shared/components/upgrade-plan-dialog/upgrade-plan-dialog.component';

/**
 * Servicio para manejar errores de límites de plan.
 * Permite mostrar el modal de upgrade desde cualquier parte de la aplicación.
 */
@Injectable({
  providedIn: 'root'
})
export class PlanErrorHandlerService {
  
  // Estado del modal
  showUpgradeDialog = signal(false);
  upgradeDialogData = signal<UpgradeDialogData | null>(null);

  /**
   * Muestra el modal de upgrade con los datos del error
   */
  showUpgradeModal(data: UpgradeDialogData) {
    this.upgradeDialogData.set(data);
    this.showUpgradeDialog.set(true);
  }

  /**
   * Cierra el modal de upgrade
   */
  closeUpgradeModal() {
    this.showUpgradeDialog.set(false);
    this.upgradeDialogData.set(null);
  }

  /**
   * Parsea un error HTTP 402 y muestra el modal
   */
  handlePlanLimitError(error: any) {
    const errorData = error.error?.data || {};
    const message = error.error?.message || 'Has alcanzado el límite de tu plan';

    const data: UpgradeDialogData = {
      tipoLimite: errorData.tipoLimite || 'EQUIPOS',
      valorActual: errorData.valorActual || 0,
      valorMaximo: errorData.valorMaximo || 0,
      planActual: errorData.planActual || 'Básico',
      mensaje: message
    };

    this.showUpgradeModal(data);
  }

  /**
   * Verifica si un error es de tipo límite de plan (HTTP 402)
   */
  isPlanLimitError(error: any): boolean {
    return error.status === 402;
  }
}